export default __webpack_public_path__ + "static/media/save-icon.67e0e57c.svg";